import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: block;
  text-align: center;
  .logo {
    margin-bottom: 56px;
  }
  .text-container {
    margin-bottom: 40px;
  }
`;
